import React, { useEffect, useRef, useState } from "react";
import {
  Grid,
  InputAdornment,
  TextField,
  IconButton,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import { ReactComponent as AddIcon } from "../../Assets/Icons/PharmsmartIcon/AddIcon.svg";
import GroupsIcon from "@mui/icons-material/Groups";
import { ReactComponent as SearchIcon } from "../../Assets/Icons/PharmsmartIcon/SearchIcon.svg";
import HtmlTooltipMain from "../../Components/Common/HtmlTooltipMain";
import { ReactComponent as AddPersonMainIcon } from "Assets/Icons/PharmsmartIcon/GroupIcon.svg";
import { connect, useSelector } from "react-redux";
import {
  START_GET_GROUP_LIST,
  START_DELETE_GROUP,
  RESET_GROUP_STATE,
  START_UPDATE_GROUP,
  START_GET_SINGLE_GROUP,
} from "../../Actions/GroupAction";
import { useIntersection } from "../../Hooks/customHooks";
import _ from "underscore";
import { useNotification } from "../../Hooks/NotificationManager";
import {
  getClearObject,
  setLocalStorage,
  getLocalStorage,
} from "../../utils/generalUtils";
import useHeaderPharmacySelection from "../../Hooks/useHeaderPharmacySelection";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import PrimaryIcon from "../../Components/Common/PrimaryIcon";
import Button from "../../Components/Common/Button/Button";
import "../../Sass/Common.scss";
import GroupTable from "./GroupTable";
import {
  START_ARCHIVE_MEDICATION,
  START_GET_PATIENT_LIST,
  START_GET_PATIENT_MEDICATION_HISTORY_LIST,
  START_GET_SINGLE_PATIENT,
} from "../../Actions/PatientAction";
import { START_GET_HOME_LIST } from "../../Actions/HomeAction";
import PatientDetailDialog from "../../Components/Patients/PatientDetailDialog";
import NextOrderDateDailog from "./NextOrderDateDailog";
import SubscriptionWaringDailog from "../../Components/Common/Dialog/SubscriptionWaringDailog";
import GroupDetailsDialog from "./GroupDetailsDialog";
const CreateGroupDialog = React.lazy(() =>
  import("../../Components/Groups/CreateGroupDialog")
);
const ConfirmationDialog = React.lazy(() =>
  import("../../Components/Common/Dialog/ConfirmationDialog")
);

const useStyle = makeStyles((theme) => ({
  rsGroupHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    padding: "6px 6px",
    // background: "#333",
    "&>div": {
      marginBottom: "0",
      [theme.breakpoints.down("768")]: {
        marginRight: "15px",
      },
      [theme.breakpoints.down("380")]: {
        marginRight: "2px",
      },
      "&>div": {
        "&>div": {
          height: "37px !important",
        },
      },
      "&>button": {
        height: "37px !important",
        marginLeft: "5px",
        marginRight: "10px",
        [theme.breakpoints.down("380")]: {
          fontSize: "0.825rem",
          padding: "0px !important",
          width: "140px",
        },
      },
    },
  },
  rsUpArrowBtn: {
    bottom: "-22px !important",
    position: "absolute",
    "&:hover": {
      cursor: "pointer",
    },
  },
  buttonFirst: {
    top: "15px !important",
    position: "absolute",
    "&:hover": {
      cursor: "pointer",
    },
  },
  align: {
    position: "relative",
    display: "grid  !important",
    right: "20px !important",
    bottom: "20px !important",
    "&>svg": {},
  },
  rsMainMarign: {
    [theme.breakpoints.down(768)]: {
      marginTop: "40px !important",
    },
  },
  search: {
    marginTop: "0px !important",
    height: "37px !important",
  },
  rsButtonHowtoIcon: {
    // background: "#7bc044 !important",
    padding: "10px !important",
    borderRadius: "5px !important",
    marginLeft: "4px",
    "&>span": {
      marginLeft: "-8px",
    },
    "&>svg": {
      "&>path": {
        fill: "white !important",
      },
    },
  },
  rsHeader: {
    display: "flex",
    justifyContent: "right",
    marginBottom: "20px",
    width: "100%",
    marginTop: "-40px",
    paddingBottom: "5px",
    marginRight: "20px",
    "&>button": {
      // marginLeft: "20px",
      fontSize: "14px",
    },
    "&>div": {
      width: "200px",
      marginRight: "-10px",
      [theme.breakpoints.down(410)]: {
        width: "150px",
        marginRight: "0px",
      },
    },
  },
  dayAutocomplete: {
    background: theme.palette.white.main,
    boxShadow: "0px 0px 10px rgb(90 104 114 / 10%)",
    borderRadius: "4px",
    lineHeight: "30px",
    minWidth: "170px !important",
    // maxWidth: "163px !important",
    whiteSpace: "onwrap",
    height: "37px !important",
    "&>div": {
      display: "flex !important",
      flexDirection: "row",
      justifyContent: "space-between !important",
      color: theme.palette.secondary.main,
      fontSize: "14px",
      height: "23px !important",
      "&>p": {
        marginLeft: "5px",
        textDecoration: "underline",
      },
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
    "& .MuiMenuItem": {
      color: theme.palette.secondary.main,
    },
  },
  todaysOrderStyle: {
    display: "-webkit-inline-box  !important",
    alignItems: "baseline;",
    whiteSpace: "nowrap",
    marginLeft: "5px",
    "&>div": {
      height: "37px !important",
      marginTop: "1px",
    },
    "&>button": {
      minWidth: "45px",
      padding: "15px 18px !important",
      marginLeft: "10px  !important",
      marginRight: "10px !important",
      height: "37px !important",
    },
    [theme.breakpoints.down("500")]: {
      marginRight: "10px  !important",
      marginBottom: "10px  !important",
    },
  },
  rsHeaderFilterContainer: {
    width: "600px !important",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    "&>button": {
      height: "37px !important",
    },
    "&>div": {
      marginLeft: "9px",
      "&>fieldset": {
        "&>legend": {
          "&>span": {
            color: "white",
          },
        },
      },
    },
  },
  menuItem: {
    display: "flex !important",
    flexDirection: "row",
    justifyContent: "space-between !important",
    "&>p": {
      marginLeft: "15px",
      textDecoration: "underline",
      color: "#114108",
    },
  },
  menuItemContainer: {
    "&>ul": {
      "&>.css-baetg6-MuiButtonBase-root-MuiMenuItem-root.Mui-selected": {
        background: "rgb(118 178 70 / 33%) !important",
      },
    },
  },
}));

const GroupMain = (props) => {
  const {
    getSGroupListAction,
    groupList,
    deleteGroupAction,
    deleteGroupData,
    updateGroupAction,
    updateGroupData,
    resetGroupState,
    getPatientListAction,
    getHomeListAction,
    getSinglePatientAction,
    getPatientHistoryAction,
    patientMedicationHistoryList,
    singlePatientData,
    getMedicationArchiveAction,
    archiveMedi,
    getSingleGroupAction,
    singleGroup,
  } = props;
  const classes = useStyle();
  const notification = useNotification();
  const [isOpenGroupModel, setIsOpenGroupModel] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [isOpenCollapse, setIsOpenCollapse] = useState(null);
  const [setTarget, entry] = useIntersection({ threshold: 0.1 });
  const [groupRecordActionType, setGroupRecordActionType] = useState("");
  const [groupRecordDeleteActionType, setGroupRecordDeleteActionType] =
    useState("");
  const [deleteGroup, setDeleteGroup] = useState(false);
  const [GroupDeleteId, setGroupDeleteId] = useState("");
  const [editGroupData, setEditGroupData] = useState({});
  const [selectedPatientId, setSelectedPatientId] = useState("");
  const GroupListRecordLimit = 50;
  const { headerSelectedPharmaciesFilter, loginUserDetail } = useSelector(
    (state) => state.user
  );
  const selectedHeaderPharmacyId = getLocalStorage("Pharmacies", true);
  // const { selectedHeaderPharmacyId } = useHeaderPharmacySelection();
  const [collapseOpen, setCollapseOpen] = useState(false);
  const [collapseIndex, setCollapseIndex] = useState();
  const [searchText, setSearchText] = useState(false);
  const showDataBasedOnRole = loginUserDetail?.data?.data?.role;
  const [patientId, setPatientId] = useState("");
  const [groupId, setGroupId] = useState("");
  const [patientDetailOpen, setPatientDetailOpen] = useState(false);
  const [isArchive, setIsArchive] = useState(false);
  const [isOpenNextOrderDate, setIsOpenNextOrderDate] = useState("");
  const [subscriptionDialog, setSubscritionDialog] = useState(false);
  const [orderBy, setOrderBy] = useState("created_at");
  const [groupDailogOpen, setGroupDailogOpen] = useState(false);
  const [groupData, setGroupData] = useState({});
  const [sortOrder, setSortOrder] = useState({
    created_at: "DESC",
    g_name: "DESC",
  });
  /* Group List API Main Function */
  const getList = (params = {}) => {
    let payload = {
      offset: 0,
      limit: GroupListRecordLimit,
      q: searchValue,
    };
    if (selectedHeaderPharmacyId && selectedHeaderPharmacyId !== "all") {
      payload.pharmacy_id = [selectedHeaderPharmacyId];
    }

    payload = {
      ...payload,
      ...params,
    };
    getSGroupListAction(getClearObject(payload));
  };
  useEffect(() => {
    let payload = {
      offset: 0,
      limit: GroupListRecordLimit,
    };
    if (
      getLocalStorage("urlgroup") == "group" &&
      selectedHeaderPharmacyId === "all"
    ) {
      getSGroupListAction(payload);
      setLocalStorage("urlgroup", "none");
    } else {
      getSGroupListAction(payload);
    }
    return () => {
      if (window.location.pathname !== "/groups") {
        // getSGroupListAction(payload);
        // window.onbeforeunload = null;
        // setLocalStorage("pharmacyChange", false);
      }
    };
  }, []);
  /* Header pharmacy selection useEffect */
  useEffect(() => {
    let payLoad = {};
    
    
    if (
        selectedHeaderPharmacyId !== "" && 
        selectedHeaderPharmacyId !== "all" && 
        selectedHeaderPharmacyId !== undefined &&
        selectedHeaderPharmacyId !== null
      ) {    
      payLoad = {
        pharmacy_id: [selectedHeaderPharmacyId],
      };
      getList(payLoad);
    } else if (getLocalStorage("pharmacyChange") == "true") {
      getList(payLoad);
    }
    // getList(payLoad);
  }, [selectedHeaderPharmacyId]);

  /* Scroll Data Show  based intersection using  useEffect */
  useEffect(() => {
    if (entry.isIntersecting) {
      if (groupList?.data?.list?.length !== groupList?.data?.filterd_record) {
        getList({
          offset: groupList?.data?.list?.length,
          limit: GroupListRecordLimit,
          ...(searchValue && {
            q: searchValue,
          }),
        });
      }
    }
  }, [entry]);

  /* Search debounce useRef */
  const searchUserDebounce = useRef(
    _.debounce((searchString, otherStateValues = {}) => {
      getList({
        ...(searchString && {
          q: searchString,
        }),
        ...otherStateValues,
      });
    }, 500)
  );

  /* Handle Search Function */
  const handleSearch = (newValue) => {
    searchUserDebounce.current(newValue, {
      pharmacy_id:
        selectedHeaderPharmacyId !== "all" ? [selectedHeaderPharmacyId] : [],
    });
  };

  /* Handle delete Group function */
  const handleDeleteGroup = () => {
    // if (loginUserDetail?.data?.data?.is_expired) {
    //   setSubscritionDialog(true);
    // } else {
    let payLoad = {
      offset: 0,
    };
    let payload = {};
    if (groupRecordDeleteActionType === "groupDelete") {
      deleteGroupAction(GroupDeleteId);
      // getPatientListAction(payLoad);
      // getHomeListAction(payload);
    } else {
      updateGroupAction(GroupDeleteId, {
        delete_patient_ids: [selectedPatientId],
        g_is_preferred_order_day: 0,
        g_is_preferred_order_gap: 0,
        g_order_date: singleGroup?.data?.g_order_date
          ? singleGroup?.data?.g_order_date
          : editGroupData?.gnod_order_date || null,
        g_cycle_day: singleGroup?.data?.g_cycle_day
          ? singleGroup?.data?.g_cycle_day
          : editGroupData?.g_cycle_day || null,
      });
      // getPatientListAction(payLoad);
      // getHomeListAction(payload);
    }

    // }
  };

  /* Handle Open Group Function */
  const handleOpen = (clickedIndex) => {
    if (isOpenCollapse === clickedIndex) {
      setIsOpenCollapse(null);
    } else {
      setIsOpenCollapse(clickedIndex);
    }
  };

  /* Delete Group Loading useEffect */
  useEffect(() => {
    if (
      (!deleteGroupData?.loading &&
        Object.keys(deleteGroupData?.data)?.length > 0) ||
      (!updateGroupData?.loading &&
        Object.keys(updateGroupData?.data)?.length > 0)
    ) {
      if (groupRecordDeleteActionType === "patientDelete") {
        notification.success("Patient Delete Successfully");
      } else {
        if (groupRecordDeleteActionType === "groupDelete") {
          setGroupDailogOpen(false);
          setGroupId("");
        }
      }
      setDeleteGroup(false);
      setGroupDeleteId("");
      resetGroupState("deleteGroupData", "");
      resetGroupState("updateGroupData", "");
      // getHomeListAction();

      if (groupId && groupRecordDeleteActionType != "groupDelete") {
        getSingleGroupAction(groupId);
        setGroupId("");
      }
    }
  }, [deleteGroupData, updateGroupData]);

  const handleMediArchive = (id) => {
    getMedicationArchiveAction(id);
    setIsArchive(true);
  };
  useEffect(() => {
    if (archiveMedi?.data?.success && isArchive) {
      getPatientHistoryAction(patientId, {
        offset: 0,
        limit: 20,
      });
      setIsArchive(false);
    }
  }, [archiveMedi?.data?.success]);

  const categoryMenuItems = [
    { index: 0, label: "Created At", key: "created_at" },
    { index: 1, label: "Group Name", key: "g_name" },
  ];

  /** handle Category */
  const handleCategorySelect = (e) => {
    let payload = {
      offset: 0,
      limit: GroupListRecordLimit,
      q: searchValue,
      test: 1,
    };
    if (e.target.value === "g_name") {
      payload.order_by = e.target.value;
      payload.sort_by = sortOrder.g_name;
    } else {
      payload.order_by = "";
      payload.sort_by = sortOrder.created_at;
    }
    setOrderBy(e.target.value);
    getList(payload);
  };

  /** handle Sort Toggle */
  const handleSortToggle = (key) => {
    const newSortOrder = sortOrder[key] === "ASC" ? "DESC" : "ASC";
    setSortOrder((prevState) => ({
      ...prevState,
      [key]: newSortOrder,
    }));
    setOrderBy(key);
    const payload = {
      offset: 0,
      limit: GroupListRecordLimit,
      q: searchValue,
      sort_by: newSortOrder,
      test: true,
      order_by: key === "g_name" ? "g_name" : "",
    };
    getList(payload);
  };

  return (
    <>
      <Grid className={classes.rsMainMarign}>
        <Grid className={classes.rsGroupHeader}>
          <Grid className={classes.rsHeader}>
            {/* <div className={classes.rsHeaderFilterContainer}> */}
            {showDataBasedOnRole !== "user" && (
              <>
                <HtmlTooltipMain title="" className="hoverAlign">
                  {/* <IconButton
                  className={clsx("btn_green", classes.rsButtonHowtoIcon)}
                  variant="contained"
                  onClick={() => {
                    setIsOpenGroupModel(true);
                    setGroupRecordActionType("createNewGroup");
                  }}
                >
                  <GroupsIcon width="20px" cursor="pointer" />
                </IconButton> */}
                  <Button
                    variant="contained"
                    className={classes.rsButtonHowtoIcon}
                    startIcon={
                      <PrimaryIcon
                        icon={AddIcon}
                        color="white"
                        width="16px"
                        height="16px"
                      />
                    }
                    onClick={() => {
                      setIsOpenGroupModel(true);
                      setGroupRecordActionType("createNewGroup");
                    }}
                  >
                    Create Group
                  </Button>
                </HtmlTooltipMain>
              </>
            )}
            {/* </div> */}
            <TextField
              withPadding={true}
              medium
              secondary
              className={classes.search}
              placeholder="Search..."
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e?.target?.value);
                handleSearch(e?.target?.value);
                setCollapseOpen(true);
                setCollapseIndex(0);
                if (e?.target?.value) {
                  setSearchText(true);
                } else {
                  setSearchText(false);
                }
              }}
              InputProps={{
                endAdornment: (
                  <>
                    <InputAdornment position="end">
                      {searchText && (
                        <div className={classes.align}>
                          <>
                            <PrimaryIcon
                              icon={ArrowDropUpIcon}
                              color="black"
                              height="3px"
                              className={classes.rsUpArrowBtn}
                              onClick={() => {
                                setCollapseOpen(false);
                                setCollapseIndex(collapseIndex - 1);
                              }}
                            />
                          </>
                          <>
                            <PrimaryIcon
                              icon={ArrowDropDownIcon}
                              className={classes.buttonFirst}
                              color="black"
                              onClick={() => {
                                setCollapseOpen(false);
                                setCollapseIndex(collapseIndex + 1);
                              }}
                            />
                          </>
                        </div>
                      )}
                      {searchText || (
                        <InputAdornment position="end">
                          <PrimaryIcon width="20px" icon={SearchIcon} />
                        </InputAdornment>
                      )}
                    </InputAdornment>
                  </>
                ),
              }}
            />
            {/* <FormControl>
              <Select
                value={orderBy}
                className={classes.dayAutocomplete}
                onChange={handleCategorySelect}
                MenuProps={{
                  classes: { paper: classes.menuItemContainer },
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  getContentAnchorEl: null,
                }}
              >
                {categoryMenuItems.map((item, index) => (
                  <MenuItem
                    key={index}
                    value={item.key}
                    name={item.label}
                    className={classes.menuItem}
                  >
                    {item.label}
                    {orderBy === item.key && (
                      <p
                        onClick={(e) => {
                          e.stopPropagation();
                          handleSortToggle(item.key);
                        }}
                        className={classes.sortBtn}
                      >
                        {sortOrder[item.key]}
                      </p>
                    )}
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}
          </Grid>
        </Grid>
        <GroupTable
          groupList={groupList}
          handleOpen={handleOpen}
          setGroupRecordActionType={setGroupRecordActionType}
          setEditGroupData={setEditGroupData}
          setIsOpenGroupModel={setIsOpenGroupModel}
          setGroupRecordDeleteActionType={setGroupRecordDeleteActionType}
          setDeleteGroup={setDeleteGroup}
          setGroupDeleteId={setGroupDeleteId}
          isOpenCollapse={isOpenCollapse}
          setSelectedPatientId={setSelectedPatientId}
          setTarget={setTarget}
          collapseOpen={collapseOpen}
          setCollapseOpen={setCollapseOpen}
          collapseIndex={collapseIndex}
          setCollapseIndex={setCollapseIndex}
          showDataBasedOnRole={showDataBasedOnRole}
          patientDetailOpen={patientDetailOpen}
          setPatientDetailOpen={setPatientDetailOpen}
          patientId={patientId}
          setPatientId={setPatientId}
          isOpenNextOrderDate={isOpenNextOrderDate}
          setIsOpenNextOrderDate={setIsOpenNextOrderDate}
          groupDailogOpen={groupDailogOpen}
          setGroupDailogOpen={setGroupDailogOpen}
          groupData={groupData}
          setGroupData={setGroupData}
        />
      </Grid>

      <PatientDetailDialog
        open={patientDetailOpen}
        setOpen={setPatientDetailOpen}
        patientId={patientId}
        setPatientId={setPatientId}
        getSinglePatientAction={getSinglePatientAction}
        data={singlePatientData}
        getPatientHistoryAction={getPatientHistoryAction}
        patientMedicationHistoryList={patientMedicationHistoryList}
        handleMediArchive={handleMediArchive}
        getList={getList}
      />
      <CreateGroupDialog
        open={isOpenGroupModel}
        setOpen={setIsOpenGroupModel}
        editData={editGroupData}
        setEditData={setEditGroupData}
        groupRecordActionType={groupRecordActionType}
        setGroupRecordActionType={setGroupRecordActionType}
        getList={getList}
        getListFlag={false}
        showAddPatientDropDown={true}
        setGroupData={setGroupData}
        groupId={groupId}
        setGroupId={setGroupId}
      />
      <NextOrderDateDailog
        open={isOpenNextOrderDate}
        setOpen={setIsOpenNextOrderDate}
        editData={editGroupData}
        setEditData={setEditGroupData}
        groupRecordActionType={groupRecordActionType}
        setGroupRecordActionType={setGroupRecordActionType}
        getList={getList}
      />
      <ConfirmationDialog
        open={deleteGroup}
        setOpen={setDeleteGroup}
        title="Are you sure?"
        body={
          groupRecordDeleteActionType === "patientDelete"
            ? "You wan't be able to undo this patient!"
            : "You wan't be able to undo this group!"
        }
        actionBtnTitle={
          groupRecordDeleteActionType === "patientDelete"
            ? "Yes Remove It!!"
            : "Yes Delete It!!"
        }
        handleSubmit={handleDeleteGroup}
        loading={deleteGroupData?.loading && updateGroupData?.loading}
      />
      <SubscriptionWaringDailog
        open={subscriptionDialog}
        setOpen={setSubscritionDialog}
      />
      <GroupDetailsDialog
        open={groupDailogOpen}
        setOpen={setGroupDailogOpen}
        groupData={groupData}
        setGroupData={setGroupData}
        showDataBasedOnRole={showDataBasedOnRole}
        setGroupRecordActionType={setGroupRecordActionType}
        setEditGroupData={setEditGroupData}
        setIsOpenGroupModel={setIsOpenGroupModel}
        setGroupRecordDeleteActionType={setGroupRecordDeleteActionType}
        setPatientId={setPatientId}
        setPatientDetailOpen={setPatientDetailOpen}
        setSelectedPatientId={setSelectedPatientId}
        setDeleteGroup={setDeleteGroup}
        setGroupDeleteId={setGroupDeleteId}
        getSingleGroupAction={getSingleGroupAction}
        singleGroup={singleGroup}
        groupId={groupId}
        setGroupId={setGroupId}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  groupList: state.group.groupList,
  deleteGroupData: state.group.deleteGroupData,
  updateGroupData: state.group.updateGroupData,
  singlePatientData: state.patient.singlePatientData,
  patientMedicationHistoryList: state.patient.patientMedicationHistoryList,
  archiveMedi: state.patient.archiveMedi,
  singleGroup: state.group.singleGroup,
});
const mapDispatchToProps = (dispatch) => ({
  getSGroupListAction: (payload) =>
    dispatch({ type: START_GET_GROUP_LIST, payload }),
  deleteGroupAction: (id) => dispatch({ type: START_DELETE_GROUP, id }),
  updateGroupAction: (id, payload) =>
    dispatch({ type: START_UPDATE_GROUP, id, payload }),
  resetGroupState: (key, payload) =>
    dispatch({ type: RESET_GROUP_STATE, key, payload }),
  getPatientListAction: (payload) =>
    dispatch({ type: START_GET_PATIENT_LIST, payload }),
  getHomeListAction: (payload) =>
    dispatch({ type: START_GET_HOME_LIST, payload }),
  getSinglePatientAction: (id) =>
    dispatch({ type: START_GET_SINGLE_PATIENT, id }),
  getPatientHistoryAction: (id, payload) =>
    dispatch({ type: START_GET_PATIENT_MEDICATION_HISTORY_LIST, id, payload }),
  getMedicationArchiveAction: (id, payload, historyPayload) =>
    dispatch({ type: START_ARCHIVE_MEDICATION, id, payload, historyPayload }),
  getSingleGroupAction: (id) => dispatch({ type: START_GET_SINGLE_GROUP, id }),
});

export default connect(mapStateToProps, mapDispatchToProps)(GroupMain);
